import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {fromEvent, Subscription} from 'rxjs';
import {AppComponent} from '../app.component';
import {Batiment} from '../Models/Batiment';
import {cloneDeep} from "lodash";
import {saveAs} from 'file-saver';
import {ROUTES_PATHS} from '../const/routes';
import {specialRenovationTypesNrjNb, specialHideSendButtonInSidebar} from "../const/utils";
import {SidebarHelper} from "../helpers/sidebar.helper";
import {EnergyClass, EnergyLetter, NrjAndGesConsom} from "../Models/EnergyClass";
import {EnergieHelper} from "../helpers/energie.helper";

@Component({
	selector: 'app-sidebar-recap',
	templateUrl: './sidebar-recap.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./sidebar-recap.component.less']
})

export class SidebarRecapComponent implements OnInit, OnDestroy {
	options: any;
	textes: any;
	modalsTxt: any = null;
	estimation: any;
	simulationEncart: any = {};
	imgDefault: any = "https://www.espace.immo/files/residences/74-ordener/slideshow/HD/1.jpg";
	diaporama: any = [];
	batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
	arrPieces = JSON.parse(localStorage.getItem("arrPieces")!);
	adrComplete: any;
	labelTypeBat: any;
	estimTotale: any;
	isTrial: any;
	isSidebarVisible = false;
	resizeSubscription: Subscription | undefined;
	totalConsom: NrjAndGesConsom | null = null;
	renovationValue: number = -1;
	public specialHideSendButtonInSidebar = specialHideSendButtonInSidebar;
	public cadreEnergetique: EnergyClass[] = [];
	public cadreGES: EnergyClass[] = [];

	constructor(
		public app: AppComponent,
		public sidebarHelper: SidebarHelper,
		public energieHelper: EnergieHelper
	) {
		this.isSidebarVisible = this.sidebarHelper.isSidebarVisible;
	}

	update(): void {
		console.log('update fonction child component');
		this.app.dataToolsService.currentTotalEstimation.subscribe(resp => {
			this.estimTotale = resp;
			console.log('update this.estimTotale => ', this.estimTotale);
		});
		this.app.dataToolsService.currentIsTrial.subscribe(resp => {
			this.isTrial = resp;
			console.log('update this.isTrial => ', this.isTrial);
		});
	}

	slideConfig = {
		infinite: false,
		speed: 300,
		initialSlide: 0,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
	};

	slickInit(e: any) {
		console.log('slick initialized');
	}

	breakpoint(e: any) {
		console.log('breakpoint');
	}

	getClassChecked(_opt: any) {
		if (!_opt || !this.batiment) return;
		let isMinorOrEqual: boolean = false;
		isMinorOrEqual = (_opt.value <= this.simulationEncart[0].Standing!) ? true : false;
		return isMinorOrEqual;
	}

	toggleSidebar() {
		this.isSidebarVisible = !this.isSidebarVisible;
		this.sidebarHelper.getAllContentStatic(this.isSidebarVisible);
	}

	ngOnDestroy() {
		this.sidebarHelper.destroySidebar();
	}

	ngOnInit(): void {
		if (!this.batiment || !this.batiment.simulationId || !this.arrPieces || this.arrPieces.length < 1) return;

		let renovation: any = localStorage.getItem("RENOVATION");
		this.renovationValue = this.app.sharedToolsService.getRenovationValue(renovation);
		console.log("renovationValue:", this.renovationValue);

		// Responsive sidebar
		this.sidebarHelper.initializeSidebar();
		this.sidebarHelper.resizeSubscriptionSetup();

		// Get the page texts
		this.app.sharedToolsService.getJSON("txtSideBarRight").subscribe(txt => {
			this.textes = cloneDeep(txt.data);
		});

		// Get the modal texts
		this.app.dataInitService.getModalTextsOnce(modalsTxt => {
			this.modalsTxt = modalsTxt;
		});

		// Calcul simulation
		this.getSimulationEncart(this.batiment.simulationId);

		// Calcul évaluation énergie
		if (specialRenovationTypesNrjNb.includes(this.renovationValue))
			this.getEvaluationEnergy(this.batiment.simulationId);

		this.app.dataToolsService.currentIsTrial.subscribe(resp => {
			this.isTrial = resp;
			console.log('update this.isTrial => ', this.isTrial);
		});
	}

	getColorDpe(letter: string, _array: any): string {
		let color = '';
		_array.forEach((item: any) => {
			if (item.lettre === letter) {
				color = item.color;
			}
		});
		return color;
	}

	getSimulationEncart(simId: any) {
		this.app.apiToolsService.getSimulationEncart(simId).subscribe(res => {
			console.log("res getSimulationEncart setMobMobilierSet ==> ", res);
			console.log("res getSimulationEncart ==> ", res);
			this.simulationEncart = res;
			//console.log("this.simulationObj[0] ==> ", this.simulationEncart[0]);

			let virgule;
			let espace;

			virgule = (this.simulationEncart[0].Adresse1 && this.simulationEncart[0].AdresseCP) ? ', ' : '';
			espace = (this.simulationEncart[0].AdresseVille) ? ' ' : '';

			this.simulationEncart[0].Adresse1 = this.simulationEncart[0].Adresse1.replace("null", "");

			this.adrComplete = this.simulationEncart[0].Adresse1 + virgule + this.simulationEncart[0].AdresseCP + espace + this.simulationEncart[0].AdresseVille;

			this.app.sharedToolsService.getJSON("selectOpts").subscribe(opts => {
				this.options = cloneDeep(opts);
				//console.log("this.options ==> ", this.options);

				this.labelTypeBat = this.app.sharedToolsService.getLabel(this.simulationEncart[0].SINTA_ID!, this.options.optsTypeBien);

				this.estimTotale = this.simulationEncart[0].MontantEstimation;

				if (!this.simulationEncart[0].Photos) this.diaporama.push(this.imgDefault);
				else this.diaporama = this.app.sharedToolsService.stringToArray(this.simulationEncart[0].Photos, ';');

				this.app.dataToolsService.setTotalEstimation(this.estimTotale);
				this.app.dataToolsService.setIsTrial(this.simulationEncart[0].IsTrial);

				//console.log("this.diaporama ==> ", this.diaporama);
			});
		});
	}

	//generer le pdf
	generatepdf() {
		console.log("simulationId:", this.batiment.simulationId);

		if (!this.batiment.simulationId) return;

		this.app.apiToolsService.generatePdf(parseInt(this.batiment.simulationId)).subscribe(
			res => {
				console.log("res---", res);

				var blob = new Blob([res], {type: "application/pdf;charset=utf-8"});
				saveAs(blob, "Estimation_" + this.batiment.simulationId?.toString() + ".pdf");
			},
			err => {
				console.log("err---", err);
			}
		)
	}

	//envoyer le pdf
	sendMailPdf() {
		console.log("simulationId:", this.batiment.simulationId);

		if (!this.batiment.simulationId) return;

		this.app.apiToolsService.sendMailPdf(parseInt(this.batiment.simulationId)).subscribe(
			res => {
				console.log("res---", res);

				this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalMailPdfOk, "alert", "", () => {
					return;
				}, () => {
					return;
				});
			},
			err => {
				console.log("err---", err);

				this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalResultKo, "alert", "", () => {
					return;
				}, () => {
					return;
				});
			}
		)
	}

	generateCadreEnergetique(thresholds: Record<string, number>, are_carbon_tresholds: boolean = false) {

		const colorA: string = (are_carbon_tresholds) ? '#abdbf9' : '#009546';
		const colorB: string = (are_carbon_tresholds) ? '#91b4d5' : '#4fae3d';
		const colorC: string = (are_carbon_tresholds) ? '#7b92b1' : '#c9d32f';
		const colorD: string = (are_carbon_tresholds) ? '#626f90' : '#fede35';
		const colorE: string = (are_carbon_tresholds) ? '#4e5272' : '#fbb92d';
		const colorF: string = (are_carbon_tresholds) ? '#393552' : '#ee6621';
		const colorG: string = (are_carbon_tresholds) ? '#271b36' : '#e5031f';

		const config: Record<EnergyLetter, { color: string; width: number }> = {
			A: {color: colorA, width: 35},
			B: {color: colorB, width: 40},
			C: {color: colorC, width: 45},
			D: {color: colorD, width: 50},
			E: {color: colorE, width: 55},
			F: {color: colorF, width: 60},
			G: {color: colorG, width: 65},
		};

		const lettres: EnergyLetter[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];

		let previousMax = 0;

		return lettres.map((lettre, index) => {
			const valeurMax = thresholds[lettre];

			let valeurMin = index === 0 ? 0 : previousMax + 1;

			let texte = '';
			if (index === 0) {
				texte = `<= ${valeurMax}`;
			} else if (lettre === 'G') {
				texte = `> ${previousMax}`;
			} else {
				texte = `${valeurMin} à ${valeurMax}`;
			}

			const result: EnergyClass = {
				lettre,
				texte,
				valeurMin,
				valeurMax,
				color: config[lettre].color,
				width: config[lettre].width,
			};

			previousMax = valeurMax;

			return result;
		});
	}

	getEvaluationEnergy(simulationId: any) {
		console.log("simulationId:", this.batiment.simulationId);

		if (!this.batiment.simulationId) return;

		this.app.apiToolsService.getEvaluationEnergy(simulationId).subscribe(res => {
			console.log("res getEvaluationEnergy ==> ", res);

			this.totalConsom = this.energieHelper.mapToNrjConsom(res);
			console.log("this.totalConsom => ", this.totalConsom);

			// Génération du cadre énergetique et du cadre GES
			this.cadreEnergetique = this.generateCadreEnergetique(this.totalConsom?.energy_thresholds, false);
			this.cadreGES = this.generateCadreEnergetique(this.totalConsom?.ges_thresholds, true);
			console.log("this.cadreEnergetique ==> ", this.cadreEnergetique);
			console.log("this.cadreGES ==> ", this.cadreGES);

			// Recupération de la valeur énergetique du logement
			let colorBefore = this.getColorDpe(this.totalConsom.before_renovation.energy_dpe_class, this.cadreEnergetique);
			let colorAfter = this.getColorDpe(this.totalConsom.after_renovation.energy_dpe_class, this.cadreEnergetique);

			this.totalConsom.before_renovation.energy_dpe_color = colorBefore;
			this.totalConsom.after_renovation.energy_dpe_color = colorAfter;
		});
	}

	public readonly ROUTES_PATHS = ROUTES_PATHS;
}
